import { openPopupPromise } from 'src/lib/popups/popupOpenClose';
import { Admin } from 'src/replicant/admin';
import { createLaunchSequence, actionBlock } from './LaunchSequence';
import { removeSplashScreen } from 'src/lib/platformUtils';

export const adminLaunchSequence = createLaunchSequence([
  /**
   * Show admin messages
   */
  actionBlock({
    skip: ({ user }) => !Admin.getters(user).hasReimbursements(),
    actions: [
      async () => {
        // Remove splash screen, with a small delay to avoid black screen flash
        setTimeout(() => removeSplashScreen(), 500);

        await openPopupPromise('popupAdminReimburse', {});

        // Continue with next action.
        return false;
      },
    ],
  }),
]);
